let prices = function (membership) {
	let checkboxType;
	if (membership == 'club') {
		var membership = membership + '-'
		$('#orderNow').attr('data-check', 'subscribe');
		checkboxType = true;
	} else {
		var membership = '';
		$('#orderNow').attr('data-check', 'un-subscribe')
		checkboxType = false;
	}

	if ($('body').hasClass('show-promoBanner')) {
		var sale = 'sale-'

	} else {
		var sale = '';
	}

	$('#orderNow').find('.purchaseMode__input').attr("checked", checkboxType);

	var banner = $('.saveBanner');
	let bannerTitle = banner.find('.title').attr('data-title');
	let bannerTitleBack = banner.find('.title').attr('data-titleback');

	if (membership == 'club-') {
		banner.find('.title').html(bannerTitleBack);
		banner.find('.text.pop').addClass('hide');
		banner.find('.text.return').removeClass('hide');
	} else {
		banner.find('.title').html(bannerTitle);
		banner.find('.text.pop').removeClass('hide');
		banner.find('.text.return').addClass('hide');
	}

	const giveAwayBanner = $('#giveAwayBanner');

	if (giveAwayBanner.length) {
		const btnAltText = $('#btnAltText')
		const btnText = $('#btnText')

		if (membership == 'club-') {
			btnAltText.removeClass('hide');
			btnText.addClass('hide');

		} else {
			btnAltText.addClass('hide');
			btnText.removeClass('hide');
		}
	}

	$('.cart .cards .card').each(function (index, el) {
		let retail, amount, saving, link, 
			unit = $(this).attr('data-units'),
			pricePerDay, 
			month = 30, 
			days;

		let param = $(el).find('.cta').attr('data-param');

		amount = $(el).find('.amount').attr('data-' + sale + membership + 'amount');
		$(el).find('.amount__value').html(amount);

		saving = $(el).find('.saving').attr('data-' + sale + membership + 'saving');
		$(el).find('.saving__value').html(saving);

		retail = $(el).find('.retail').attr('data-' + sale + membership + 'retail');
		$(el).find('.retail__value').html(retail);

		link = $(el).find('.cta').attr('data-' + sale + membership + 'tracker');
		$(el).find('.cta').attr('href', link + param);

		/**
		 * Calculate Price Per Day
		 */
		function calcPricePerDay(el, amount, unit, month) {
			// console.log('amount', amount);
			// console.log('unit', unit);
			// console.log('month', month);

			//- Split amount and convert into number
			let amountNum = amount.replace('$', '');
			
			//- Calculate months into days
			days = unit * month;
			// console.log('days', days);

			pricePerDay = (amountNum / days).toFixed(2);

			// console.log('pricePerDay', pricePerDay);

			// console.log($(el));

			$(el).find('.price-per-day__value').html('$' + pricePerDay);
			
		}

		calcPricePerDay(el, amount, unit, month);
	});

	/**
	 * Handle Strawberry Image banner when under sale mode
	 */
	const bannerImgEl = $('#bannerImage'); //- define Image Element
	const bannerImgPath = 'https://dtjlhiahlv53j.cloudfront.net/assets/nucific/';
	let bannerImgD, bannerImgT, bannerImgM, bannerImgVersion;

	//- Check if we're on sale time period but not under club prices
	if ($('body').hasClass('show-promoBanner') && !$('body').hasClass('show-promoBanner--club')) {
		bannerImgD = bannerImgEl.attr('data-sale-image-d');
		bannerImgT = bannerImgEl.attr('data-sale-image-t');
		bannerImgM = bannerImgEl.attr('data-sale-image-m');

	} else {
		bannerImgD = bannerImgEl.attr('data-image-d');
		bannerImgT = bannerImgEl.attr('data-image-t');
		bannerImgM = bannerImgEl.attr('data-image-m');
	}

	//- manipulate banner image size
	if (window.innerWidth > 1024) {
		bannerImgVersion = bannerImgD;

	} else if (window.innerWidth < 768) {
		bannerImgVersion = bannerImgM;

	} else {
		bannerImgVersion = bannerImgT;
	}

	// console.log(bannerImgEl.src = bannerImgPath + bannerImg + bannerImgVersion + '.jpg');

	bannerImgEl.attr('src', bannerImgPath + bannerImgVersion);
};

$(document).ready(function () {
	/**
	 * Calc height of sticky CTA to adjust position
	 */
	let stickyCta = $('#buyNowSticky');

	if($(stickyCta).length) {
		function stickyCtaTopPos() {	
			let stickyCtaHeight = Math.floor($(stickyCta).outerHeight());
	
			document.documentElement.style.setProperty('--stickyCtaTopPos', stickyCtaHeight + 'px');

			// console.log(stickyCtaHeight);
		}

		stickyCtaTopPos();
	
		//- seTimeout for window resizing
		let resizeTimer;
	
		$(window).on('resize', function(e) {
			clearTimeout(resizeTimer);
	
			resizeTimer = setTimeout(function() {
				stickyCtaTopPos();
			}, 250);
	
		});
	}

	//salesBanner
	if ($('#salesBanner').length) {
		let salesBannerHeight = Math.floor($('#salesBanner').height());

		if ($('#salesBanner').hasClass('isStick')) {
			$('#salesBanner, .cta.btn:not(.param), #promoBanner').on('click', function (event) {
				$('html, body').animate({
					scrollTop: $(".saveBanner, #giveAwayBanner").offset().top - salesBannerHeight
				}, 1000);
			});
		} else {
			$('#salesBanner, .cta.btn:not(.param), #promoBanner').on('click', function (event) {
				$('html, body').animate({
					scrollTop: $(".saveBanner, #giveAwayBanner").offset().top
				}, 1000);
			});
		}
	} else {
		//// Take to shooping cart ////
		$('.cta.btn:not(.param), #promoBanner').on('click', function (event) {
			let promoBannerH = Math.floor($('#promoBanner').height());

			if ($('body').hasClass('show-promoBanner') && !$('body').hasClass('show-promoBanner--club')) {
				if ($('#giveAwayBanner').length) {
					$('html, body').animate({
						scrollTop: $("#giveAwayBanner").offset().top - promoBannerH
					}, 1200);
				} else {
					$('html, body').animate({
						scrollTop: $("#promoBannerAnchor").offset().top
					}, 1200);
				}

			} else {
				$('html, body').animate({
					scrollTop: $(".saveBanner, #giveAwayBanner").offset().top
				}, 1200);
			}
		});
	}

	// Top Section Animated Dots
	//- About Video Dots Animation
	let num = 0;
	function timeoutDotsAnimation() {
		setTimeout(function () {
			const el = $('#aboutProductBanner .about-product__item');
			// console.log('num', num);

			(num === 4) ? num = 1 : num++;

			el.removeClass('about-product__item--anim');
			$('#aboutProductBanner .about-product__item[data-num=' + num + ']').addClass('about-product__item--anim');
			timeoutDotsAnimation();
		}, 3000);
	}

	timeoutDotsAnimation();

	/////////////////////////////////video listener///////////////////////////////
	if ($('#topVSL').length > 0) {
		videojs('topVSL').ready(function () {
			this.on('timeupdate', function () {
				if (this.currentTime() >= (60 * 7)) {
					$('.videoWrapper .cta-wrap').addClass('show');
				}
				// console.log(this.currentTime());
			})
		});
	}

	/////////////////////////////// cart slider ///////////////////////////////

	$('.cart .cards').slick({
		mobileFirst: true,
		variableWidth: false,
		slidesToShow: 1,
		dots: true,
		speed: 300,
		centerMode: true,
		centerPadding: '50px',
		slidesToShow: 1,
		initialSlide: 1,
		responsive: [
			{
				breakpoint: 360,
				settings: {
					centerPadding: '88px',
				}
			},
			{
				breakpoint: 766,
				settings: {
					centerPadding: '105px',
				}
			},
			{
				breakpoint: 767,
				settings: 'unslick'
			}

		]
	});

	/////////////////////////////// Change to Club ///////////////////////////////	
	const CTA = $('#orderNow .cta');
	prices('no-club');

	$(".club .yes, .saveBanner .checkboxStyle").on('click', function (check) {
        handleSubscribe(this);
    });

	$('.purchaseMode__input').on('click', function (check) {
        handleSubscribe(this);
    });    

	function handleSubscribe() {
		if ($('body').hasClass('show-promoBanner')) {
			$('body').addClass('show-promoBanner--club');
		}
		if ($('.saveBanner .checkboxStyle').length > 0) {
			$('#orderNow .cta').html('Subscribe & Save');
			$('.club2').removeClass('hide').addClass('show');
		}

		if ($('#orderNow').attr('data-check') === 'un-subscribe') {
			prices('club');
		} else {
			 prices('no-club');
		 }
	}

	$('.saveBanner .checkboxStyle, .giveAwayBanner__btn, .text.return').on('click', function (event) {
		if ($(this).hasClass('return')) {
			if ($('body').hasClass('show-promoBanner')) {
				$('body').removeClass('show-promoBanner--club');
			}

			if ($('.saveBanner .checkboxStyle').length > 0) {
				CTA.html('BUY NOW');
				$('.club2').removeClass('show').addClass('hide');

			}

			prices('no-club');
		}
	});

	/**
	 * Reviews Video
	 */
	if ($('#reviewsVideoSlider').length) {
		$('#reviewsVideoSliderList').slick({
			infinite: false,
			slidesToShow: 1,
			adaptiveHeight: false,
			speed: 1000,
			centerMode: true,
			centerPadding: '30px',
			arrows: false,
			dots: true
		});
	}

	//////////////////////// hamburger ////////////////////////
	(function () {
		var hamburger = {
			navToggle: document.querySelector('.nav-toggle'),
			nav: document.getElementById('nav'),
			salesBanner: document.querySelector('.salesBanner'),

			doToggle: function (e) {
				e.preventDefault();
				this.navToggle.classList.toggle('expanded');
				this.nav.classList.toggle('expanded');
				this.salesBanner.classList.toggle('hide');
			}
		};

		if ($('#nav').length) {
			hamburger.navToggle.addEventListener('click', function (e) { hamburger.doToggle(e); });
		}

	}());

	//- Set current Year to footer Copyright
	let thisDate = new Date();
	$('#year').html(thisDate.getFullYear());
});

$(window).on("load", function() {
	/**
   * Check if has 'shipment' url parameter that came from survey page and choose the relevant option on product page
   */

	if (document.location.href.includes('shipment=shipment1')) {
		prices('club');

		if ($('body').hasClass('show-promoBanner')) {
			$('body').addClass('show-promoBanner--club');
		}

		$('html, body').animate({
			scrollTop: $(".saveBanner").offset().top - 29
		}, 1200);
	}
});
